import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button } from '@mui/material';
import { LANDING_FONTS } from '../landingVisual';
import { resolvePublicAuthPath } from '../../../utils/returningUser';

const fontSx = { fontFamily: LANDING_FONTS.sans };

const VARIANT_STYLES = {
  demoPrimary: {
    variant: 'contained',
    sx: {
      ...fontSx,
      bgcolor: '#0F172A',
      color: '#fff',
      fontWeight: 600,
      px: 3,
      py: 1.25,
      textTransform: 'none',
      borderRadius: 1.5,
      boxShadow: 'none',
      '&:hover': { bgcolor: '#1E293B', boxShadow: 'none' },
    },
  },
  secondary: {
    variant: 'outlined',
    sx: {
      ...fontSx,
      fontWeight: 600,
      px: 3,
      py: 1.25,
      textTransform: 'none',
      borderRadius: 1.5,
      borderWidth: 1,
      borderColor: 'divider',
      '&:hover': { borderWidth: 1, borderColor: 'primary.main', bgcolor: 'action.hover' },
    },
  },
  candidate: {
    variant: 'contained',
    sx: {
      ...fontSx,
      fontWeight: 600,
      px: 3,
      py: 1.25,
      textTransform: 'none',
      borderRadius: 1.5,
      boxShadow: 'none',
      '&:hover': { boxShadow: 'none' },
    },
  },
  interviewer: {
    variant: 'outlined',
    sx: {
      ...fontSx,
      fontWeight: 600,
      px: 3,
      py: 1.25,
      textTransform: 'none',
      borderRadius: 1.5,
      borderWidth: 1,
      '&:hover': { borderWidth: 1 },
    },
  },
  heroPrimary: {
    variant: 'contained',
    sx: {
      ...fontSx,
      px: 3.5,
      py: 1.35,
      fontSize: '1rem',
      fontWeight: 700,
      textTransform: 'none',
      borderRadius: 1.5,
      bgcolor: '#fff',
      color: '#0B1220',
      boxShadow: 'none',
      '&:hover': { bgcolor: 'rgba(255,255,255,0.92)', boxShadow: 'none' },
    },
  },
  heroSecondary: {
    variant: 'outlined',
    sx: {
      ...fontSx,
      px: 3.5,
      py: 1.35,
      fontSize: '1rem',
      fontWeight: 600,
      textTransform: 'none',
      borderRadius: 1.5,
      borderColor: 'rgba(255,255,255,0.45)',
      color: '#fff',
      '&:hover': {
        borderColor: '#fff',
        bgcolor: 'rgba(255,255,255,0.06)',
      },
    },
  },
  heroDemo: {
    variant: 'contained',
    sx: {
      ...fontSx,
      bgcolor: 'rgba(255,255,255,0.12)',
      color: '#fff',
      fontWeight: 600,
      px: 3.5,
      py: 1.35,
      fontSize: '1rem',
      textTransform: 'none',
      borderRadius: 1.5,
      border: '1px solid rgba(255,255,255,0.25)',
      boxShadow: 'none',
      '&:hover': { bgcolor: 'rgba(255,255,255,0.18)', boxShadow: 'none' },
    },
  },
};

const LandingCtaButton = ({
  to,
  label,
  variant = 'secondary',
  size = 'large',
  fullWidth = false,
  onDark = false,
  ...rest
}) => {
  let config = VARIANT_STYLES[variant] || VARIANT_STYLES.secondary;

  if (onDark && variant === 'heroPrimary') {
    config = VARIANT_STYLES.heroPrimary;
  }
  if (onDark && variant === 'secondary') {
    config = VARIANT_STYLES.heroSecondary;
  }
  if (onDark && (variant === 'demoPrimary' || variant === 'demo')) {
    config = VARIANT_STYLES.heroDemo;
  }
  if (onDark && variant === 'interviewer') {
    config = VARIANT_STYLES.heroSecondary;
  }

  const href = resolvePublicAuthPath(to);

  const isHashOrExternal =
    typeof href === 'string' && (href.startsWith('http') || href.startsWith('#') || href.includes('#'));

  if (isHashOrExternal && href.startsWith('http')) {
    return (
      <Button
        component="a"
        href={href}
        variant={config.variant}
        size={size}
        fullWidth={fullWidth}
        sx={config.sx}
        {...rest}
      >
        {label}
      </Button>
    );
  }

  return (
    <Button
      component={RouterLink}
      to={href}
      variant={config.variant}
      size={size}
      fullWidth={fullWidth}
      sx={config.sx}
      {...rest}
    >
      {label}
    </Button>
  );
};

export default LandingCtaButton;
